import {ColDef, ICellRendererParams} from "ag-grid-community";
import {t} from "i18next";
import {ReactNode} from "react";
import type {ExcessGroupEntityResponse} from "../../api/types/excessGroup";
import {dateFormatter} from "../../utils";

export const excessGroupColDef = ({
                                      actionsRenderer,
                                      actionColDef,
                                      user
                                  }: {
    actionsRenderer: (params: ICellRendererParams) => ReactNode;
    actionColDef: ColDef
    user: any
}): ColDef<ExcessGroupEntityResponse>[] => [
    {
        field: "legalEntities",
        headerName: t("pricing:excessGroup.table.headers.legalEntities"),
        headerTooltip: t("pricing:excessGroup.table.headers.legalEntities"),
        editable: false,
        flex: 1,
        filter: "text",
        cellRenderer: (params: ICellRendererParams) => t('translation:legalEntities.'.concat(params.data.legalEntity)),
        hide: user.legalEntities.length === 1 && user.dealers.length === 1 ? true : false
    },
    {
        field: "dealers",
        headerName: t("pricing:excessGroup.table.headers.dealers"),
        headerTooltip: t("pricing:excessGroup.table.headers.dealers"),
        editable: false,
        flex: 1,
        filter: "text",
        cellRenderer: (params: ICellRendererParams) => t('translation:dealers.'.concat(params.data.dealer)),
        hide: user.legalEntities.length === 1 && user.dealers.length === 1 ? true : false
    },
    {
        headerName: t("pricing:excessGroup.table.headers.name"),
        headerTooltip: t("pricing:excessGroup.table.headers.name"),
        field: "name",
        sortable: true,
        flex: 1,
        filter: "text"
    },
    {
        headerName: t("pricing:excessGroup.form.labels.description"),
        headerTooltip: t("pricing:excessGroup.form.labels.description"),
        field: "description",
        sortable: true,
        flex: 1
    },
    {
        headerName: t("pricing:excessGroup.form.labels.commercialSegment"),
        headerTooltip: t("pricing:excessGroup.form.labels.commercialSegment"),
        field: "commercialSegmentId",
        cellRenderer: (params: ICellRendererParams) => params.data.commercialCategory.commercialSegment.name,
        flex: 1,
        sortable: true,
        filter: "text"
    },
    {
        headerName: t("pricing:excessGroup.table.headers.commercialCategory"),
        headerTooltip: t("pricing:excessGroup.table.headers.commercialCategory"),
        field: "commercialCategoryId",
        cellRenderer: (params: ICellRendererParams) => {
            const category = params.data?.commercialCategory;
            const legalEntity = params.data?.legalEntity;
            
            if (!category) {
                return '';
            }
            
            if (!category.labels || category.labels.length === 0) {
                return category.name || '';
            }
            
            const labelObj = category.labels.find((l: any) => l.country === legalEntity);
            return labelObj?.label || category.name || '';
        },
        flex: 1,
        sortable: true,
        filter: "text"
    },
    {
        headerName: t("pricing:excessGroup.table.headers.validityDateFrom"),
        headerTooltip: t("pricing:excessGroup.table.headers.validityDateFrom"),
        field: "validityDateFrom",
        valueFormatter: (params) => params.data?.validityDateFrom ? dateFormatter(params.data?.validityDateFrom) : "",
        flex: 1,
        sortable: true,
        filter: "text"
    },
    {
        headerName: t("pricing:excessGroup.table.headers.validityDateTo"),
        headerTooltip: t("pricing:excessGroup.table.headers.validityDateTo"),
        field: "validityDateTo",
        valueFormatter: (params) => params.data?.validityDateTo ? dateFormatter(params.data?.validityDateTo) : "",
        flex: 1,
        sortable: true,
        filter: "text"
    },
    {
        ...actionColDef,
        cellRenderer: actionsRenderer
    }
];
